export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 border border-primary-200 mb-4">
            <i className="ri-information-line text-primary-600 text-sm"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">关于我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            关于无极
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            了解无极电影网的故事与使命
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-50 rounded-3xl border border-background-200/60 p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">2018</div>
                <p className="text-sm text-foreground-200 mt-2">年创立至今</p>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">30000+</div>
                <p className="text-sm text-foreground-200 mt-2">部影片资源</p>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">5000万+</div>
                <p className="text-sm text-foreground-200 mt-2">月活跃用户</p>
              </div>
            </div>

            <div className="space-y-5 text-sm md:text-base text-foreground-100 leading-relaxed">
              <p>
                无极电影网创立于2018年，是国内领先的免费在线电影观看平台。我们致力于为全球华语影迷提供最新、最全、最高清的电影资源，让每一位用户都能零门槛享受优质的观影体验。
              </p>
              <p>
                我们的内容团队每日精心筛选全球优质影片，涵盖院线大片、经典佳片、独立电影、纪录片等多种类型。依托强大的极速播放引擎和多线CDN加速技术，无极电影网实现了蓝光画质下的流畅播放，彻底告别卡顿和缓冲。
              </p>
              <p>
                无极电影网始终坚持"免费、高清、安全"的核心理念。全站无弹窗广告、无恶意跳转、无强制注册，为影迷打造纯净的观影环境。我们相信，好电影值得被更多人看到。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}